// extracted by mini-css-extract-plugin
export default {"popup":"styles_popup__tRo65","title":"styles_title__0aUYp","content":"styles_content__F6JBl"};